/**
 * Allow only mobile phone numbers
 */
export function mobilePhoneValidation(message) {
  return this.test('mobilePhoneNumber', '', async function (value) {
    const {
      path,
      createError
    } = this;
    if (!value) return true;
    const parsePhoneNumberFromString = (await import('libphonenumber-js/mobile')).parsePhoneNumberFromString;
    try {
      const isValid = parsePhoneNumberFromString(value || '')?.isValid();
      if (isValid) return isValid;
    } catch {
      // Ignore parsing errors
    }
    return createError({
      path,
      message
    });
  });
}